import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user : {}
    },
    mutations: {
        auth_request(state){
        state.status = 'loading'
        },
        auth_success(state, token, user){
        state.status = 'success'
        state.token = token
        state.user = user
        },
        auth_error(state){
        state.status = 'error'
        },
        logout(state){
        state.status = ''
        state.token = ''
        },
        sent(state){
            state.status = 'sent'
        }
    },
    actions: {
        login({commit}, user){
            return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: 'https://api.lalabumapp.com/oauth/token', data: user, method: 'POST' })
                .then(resp => {
                    const token = resp.data.access_token
                    localStorage.setItem('token', token)
                    axios.defaults.headers.common['Authorization'] = token
                    commit('auth_success', token, user)
                    resolve(resp)
                    })
                .catch(err => {
                    commit('auth_error')
                    localStorage.removeItem('token')
                    reject(err)
                    })
                })
        },
        register({commit}, user){
            return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: 'https://api.lalabumapp.com/api/v1.0/license/activeAddUser', data: user, method: 'POST' })
                .then(resp => {
                    // const token = resp.data.token
                    // const user = resp.data.user
                    // localStorage.setItem('token', token)
                    // // Add the following line:
                    // axios.defaults.headers.common['Authorization'] = token
                    // commit('auth_success', token, user)
                    if (resp.data.meta.status =="200") {
                        let username = user.email 
                        let password = user.password
                        let client_id= '5c6c4ada410dfba504749c41';
                        let client_secret = 'pP9s493s8xlzADfdMneOEgzrZ3J5l46CLXk5OLE8'
                        let grant_type = 'password'
                        let scope = '*'
                        this.dispatch('login', { grant_type, username, password,client_id,client_secret,scope })
                    }
                    resolve(resp)
                    })
                .catch(err => {
                    commit('auth_error', err)
                    localStorage.removeItem('token')
                    reject(err)
                    })
            })
        },
        logout({commit}){
            return new Promise((resolve) => {
            commit('logout')
            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
            resolve()            
            })
        },
        send_mail({commit},mail){
            return new Promise((resolve, reject) => {
                commit('sent')
                axios({url: 'https://lalabumapp.com:8443/ContactMail', data: mail, method: 'POST' })
                    .then(resp => {                        
                        resolve(resp)
                        })
                    .catch(err => {                        
                        reject(err)
                        })
                    })

        }
        },
    getters : {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    }
})
